<template>
    <div class="modal" v-bind:class="{ 'is-active': isOpen }">
        <div class="modal-background" @click="$emit('toggleModal')" />
        <div class="modal-card" :style="modalStyles">
            <header class="modal-card-head" :style="cardHeaderStyles ? cardHeaderStyles : {}">
                <slot class="modal-card-title" name="title"></slot>
                <button class="delete" aria-label="close" @click="$emit('toggleModal')">
                    <img src="@/assets/icons/actions/close-icon.svg" />
                </button>
            </header>
            <section class="modal-card-body" :style="cardBodyStyles ? cardBodyStyles : {}">
                <slot :name="slotName ? slotName : 'body'"></slot>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    name: "Modal",

    props: {
        isOpen: Boolean,
        maxWidth: String,
        minWidth: String,
        maxHeight: String,
        minHeight: String,
        // custom styles
        cardStyles: Object,
        cardHeaderStyles: Object,
        cardBodyStyles: Object,
        // dynamic slots
        slotName: String,
    },

    computed: {
        modalStyles() {
            let styles = {};

            if (this.cardStyles) styles = { ...this.cardStyles };
            if (this.maxWidth) styles["max-width"] = this.maxWidth;
            if (this.minWidth) styles["min-width"] = this.minWidth;
            if (this.maxHeight) styles["max-height"] = this.maxHeight;
            if (this.minHeight) styles["min-height"] = this.minHeight;

            return styles;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/styles/_main.scss";

a {
    text-decoration: none;
}

.modal-background {
    background-color: #504141;
    opacity: 0.5;
}

.modal-card {
    width: 100%;
    height: 100%;
    overflow: auto;
    border-radius: 12px;
}

.modal-card-head {
    background-color: $lighter;
    border-bottom: none;
    padding: 30px;

    p.modal-card-title {
        font-size: 20px;
        color: #000000;
    }
}

.modal-card-body {
    background-color: $lighter;
    display: flex;
    flex-wrap: wrap;
    padding: 0 30px 30px 30px;
    align-items: center;
    align-content: flex-start;
    justify-content: center;
}

.modal-card-foot {
    background-color: $lighter;
    border-top: none;

    button {
        width: 33px;
        background-color: #fe5775;
        color: white;
        height: 54px;
        border-radius: 16px;
        font-size: 16px;
        outline: none;
        border: none;

        a {
            color: white;
        }

        &:hover {
            opacity: 0.8;
        }
    }
}

button.delete {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 33px;
    height: 33px;

    background-color: $lighter;
    border-radius: 100%;
    outline: none;
    box-shadow: 0px 0px 6px rgba(103, 11, 11, 0.6);
    border: none;

    cursor: pointer;
}

@media only screen and (max-width: $breakpoint-medium) {
    .modal-card-head {
        p.modal-card-title {
            font-size: 16px;
        }

        p.modal-card-title.mobile {
            font-size: 28px;
        }
    }

    .modal-card {
        width: 318px;
    }
}
</style>
